<template>
  <vs-card class="pl-5 pt-5 pr-1 m-0">
    <div>
      <a href="#" @click="$emit('changeTab','ComponentClientActivity')">
        <h4 class="title-report font-semibold">Client Activity</h4>
      </a>
      <p class="text-base font-medium">Summary of billable client activity. <a href="#"></a></p>
    </div>
    <div>
      <a href="#" @click="$emit('changeTab','ComponentClientLedger')">
        <h4 class="title-report font-semibold">Client Ledger</h4>
      </a>
      <p class="text-base font-medium">Detailed report of all Client balances. <a href="#"></a></p>
    </div>
    <div>
      <a href="#" @click="$emit('changeTab','ComponentClientAccountLedger')">
        <h4 class="title-report font-semibold">Client Account Ledger</h4>
      </a>
      <p class="text-base font-medium	">Detailed report of Client and Matter client account balances.<a href="#"></a></p>
    </div>
    <div>
      <a href="#" @click="$emit('changeTab','ComponentAccountManagement')">
        <h4 class="title-report font-semibold">Client Account Management</h4>
      </a>
      <p class="text-base font-medium	">Summary of unbilled activities and available client account balances.<a href="#"></a></p>
    </div>
    <div>
      <a href="#" @click="$emit('changeTab','ComponentTrustListing')">
        <h4 class="title-report font-semibold">Client Account Listing</h4>
      </a>
      <p class="text-base font-medium">Summary of client account balances.<a href="#"></a>
      </p>
    </div>
    <div>
      <a href="#" @click="$emit('changeTab','ComponentWorkProgress')">
        <h4 class="title-report font-semibold">Work In Progress</h4>
      </a>
      <p class="text-base font-medium">Ongoing/unbilled Client activity.<a href="#"></a>
      </p>
    </div>
    <div>
      <a href="#" @click="$emit('changeTab','ComponentBankAccountActivity')">
        <h4 class="title-report font-semibold">Bank Account Activity</h4>
      </a>
      <p class="text-base font-medium">Report of financial transactions.<a href="#"></a>
      </p>
    </div>
  </vs-card>
</template>

<script>
export default {
name: "ClientReport"
}
</script>

<style scoped>

</style>
